var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { darken } from 'polished';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var Dimensions;
(function (Dimensions) {
    Dimensions["tiny"] = "tiny";
    Dimensions["small"] = "small";
    Dimensions["regular"] = "regular";
    Dimensions["large"] = "large";
})(Dimensions || (Dimensions = {}));
var Appearances;
(function (Appearances) {
    Appearances["primary"] = "primary";
    Appearances["secondary"] = "secondary";
    Appearances["alert"] = "alert";
    Appearances["success"] = "success";
    Appearances["warning"] = "warning";
    Appearances["transparent"] = "transparent";
})(Appearances || (Appearances = {}));
export var Button = withProps(styled.button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    var getBasicStyleObject = function (appearance, hollow) {
        switch (true) {
            case appearance === 'primary' && !hollow: {
                return {
                    color: props.theme.datashop.palette.white.main,
                    backgroundColor: props.theme.datashop.palette.blue.main,
                    border: props.theme.datashop.palette.blue.main,
                };
            }
            case appearance === 'primary' && hollow: {
                return {
                    color: props.theme.datashop.palette.blue.main,
                    backgroundColor: 'transparent',
                    border: props.theme.datashop.palette.blue.main,
                };
            }
            case appearance === 'secondary' && !hollow: {
                return {
                    color: props.theme.datashop.palette.neutral.main,
                    backgroundColor: props.theme.datashop.palette.stone.light,
                    border: props.theme.datashop.palette.stone.light,
                };
            }
            case appearance === 'secondary' && hollow: {
                return {
                    color: props.theme.datashop.palette.night.light,
                    backgroundColor: 'transparent',
                    border: props.theme.datashop.palette.stone.main,
                };
            }
            case appearance === 'alert' && !hollow: {
                return {
                    color: props.theme.datashop.palette.white.main,
                    backgroundColor: props.theme.datashop.palette.red.main,
                    border: props.theme.datashop.palette.red.main,
                };
            }
            case appearance === 'alert' && hollow: {
                return {
                    color: props.theme.datashop.palette.red.main,
                    backgroundColor: 'transparent',
                    border: props.theme.datashop.palette.red.main,
                };
            }
            case appearance === 'warning' && !hollow: {
                return {
                    color: props.theme.datashop.palette.white.main,
                    backgroundColor: props.theme.datashop.palette.yellow.main,
                    border: props.theme.datashop.palette.yellow.main,
                };
            }
            case appearance === 'warning' && hollow: {
                return {
                    color: props.theme.datashop.palette.yellow.main,
                    backgroundColor: 'transparent',
                    border: props.theme.datashop.palette.yellow.main,
                };
            }
            case appearance === 'success' && !hollow: {
                return {
                    color: props.theme.datashop.palette.white.main,
                    backgroundColor: props.theme.datashop.palette.green.main,
                    border: props.theme.datashop.palette.green.main,
                };
            }
            case appearance === 'success' && hollow: {
                return {
                    color: props.theme.datashop.palette.green.main,
                    backgroundColor: 'transparent',
                    border: props.theme.datashop.palette.green.main,
                };
            }
            case appearance === 'transparent': {
                return {
                    color: props.theme.datashop.palette.night.light,
                    backgroundColor: 'transparent',
                    border: 'transparent',
                };
            }
            default: {
                return {
                    color: props.theme.datashop.palette.night.light,
                    backgroundColor: props.theme.datashop.palette.stone.light,
                    border: props.theme.datashop.palette.night.light,
                };
            }
        }
    };
    var basicStyleObject = getBasicStyleObject(props.appearance, props.hollow);
    var getBasicStyle = function (styleObject) { return "\n      color: " + styleObject.color + ";\n      background-color: " + styleObject.backgroundColor + ";\n      border: solid 1px " + styleObject.border + ";\n    "; };
    var basicStyle = getBasicStyle(basicStyleObject);
    var disabledPropStyle = props.disabled
        ? "\n      cursor: not-allowed;\n      pointer-events: none;\n      opacity: 0.3;\n    "
        : "\n      cursor: pointer;\n    ";
    var expandedStyle = props.expanded
        ? "\n      width: 100%;\n    "
        : '';
    var dimensionStyle = (function () {
        var fontSizes = {
            tiny: '13px',
            small: '14px',
            regular: '14px',
            large: '16px',
        };
        var lineHeight = { tiny: 1.15, small: 1.3, regular: 1, large: 1.15 };
        var padding = {
            tiny: '4px 8px',
            small: '4px 12px',
            regular: '8px 12px',
            large: '8px 16px',
        };
        var height = {
            tiny: '24px',
            small: '28px',
            regular: '32px',
            large: '40px',
        };
        return "\n        font-size: " + fontSizes[props.dimension] + ";\n        padding: " + padding[props.dimension] + ";\n        line-height: " + lineHeight[props.dimension] + ";\n        height: " + height[props.dimension] + ";\n      ";
    })();
    var outline = {
        secondary: props.theme.datashop.palette.stone.dark,
        primary: props.theme.datashop.palette.blue.main,
        alert: props.theme.datashop.palette.red.main,
        warning: props.theme.datashop.palette.yellow.main,
        success: props.theme.datashop.palette.green.main,
        transparent: props.theme.datashop.palette.stone.dark,
    };
    var getHoverBackgroundColor = function () {
        if (props.appearance === 'transparent') {
            return "background-color: " + darken(0.08, props.theme.datashop.palette.stone.light);
        }
        else if (!props.hollow) {
            return "background-color: " + darken(0.08, basicStyleObject.backgroundColor);
        }
        else {
            return getBasicStyle(getBasicStyleObject(props.appearance, false));
        }
    };
    var getHoverBorder = function () {
        if (props.appearance === 'transparent') {
            return "border: 1px solid " + darken(0.08, props.theme.datashop.palette.stone.light);
        }
        else if (!props.hollow) {
            return "border: 1px solid " + darken(0.08, basicStyleObject.backgroundColor);
        }
        else {
            return getBasicStyle(getBasicStyleObject(props.appearance, false));
        }
    };
    var getActiveBackgroundColor = function () {
        if (props.appearance === 'transparent') {
            return "background-color: " + darken(0.16, props.theme.datashop.palette.stone.light);
        }
        else if (!props.hollow) {
            return "background-color: " + darken(0.16, basicStyleObject.backgroundColor);
        }
        else {
            return getBasicStyle(getBasicStyleObject(props.appearance, false));
        }
    };
    return "\n      border: none;\n      border-radius: 3px;\n      box-sizing: border-box;\n      font-weight: " + props.theme.datashop.weights.regular + ";\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      transition: background-color 0.25s ease-out, color 0.25s ease-out;\n      > * {\n        font-size: inherit;\n      }\n      " + dimensionStyle + "\n      " + expandedStyle + "\n      " + disabledPropStyle + "\n      " + basicStyle + "\n\n      &:hover {\n        " + getHoverBackgroundColor() + ";\n        " + getHoverBorder() + ";\n      }\n\n      &:focus {\n        outline-style: auto;\n        outline-width: 3px; \n        outline-offset: 1px;\n        outline-color: " + outline[props.appearance] + ";\n      }\n\n      &:active {\n        " + getActiveBackgroundColor() + ";\n      }\n    ";
});
Button.defaultProps = {
    appearance: 'secondary',
    hollow: false,
    disabled: false,
    expanded: false,
    dimension: 'regular',
};
export { Dimensions, Appearances, };
export default Button;
var templateObject_1;
//# sourceMappingURL=Button.js.map